import { useQuery } from '@tanstack/react-query'
import { 
  getLeadPrimaries,
  getLeadPrimary,
  getListManagement
} from "./api"

// Get list of lead primaries
export const useGetLeadPrimaries = ({ params, enabled = true }) => {
  return useQuery({
    queryKey: ['get-lead-primaries', params],
    queryFn: () => getLeadPrimaries(params),
    enabled: enabled
  })
}

// Get single lead primary by ID
export const useGetLeadPrimary = ({ leadId, enabled = true }) => {
  return useQuery({
    queryKey: ['get-lead-primary', leadId],
    queryFn: () => getLeadPrimary(leadId),
    enabled: enabled && !!leadId
  })
}

// Legacy hook (keeping for backward compatibility)
export const useGetListManagement = ({ params, enabled = true }) => {
  return useQuery({
    queryKey: ['get-list-management', params],
    queryFn: () => getListManagement(params),
    enabled: enabled
  })
}
